module.exports = __webpack_public_path__ + "static/media/badge.5b31b259.svg";